<template>
  <div
    class="card"
    :style="{
      borderColor: borderColor || 'white', 
      borderWidth: !!borderColor ? '3px' : '0'
    }"
  >
    <div class="card-header" :style="{backgroundColor: headerBgColor, color: headerColor}" v-if="title">{{title}}</div>
    <div class="card-content">
      <slot></slot>
    </div>
    <div class="card-footer">
      <slot name="footer"></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String
    },
    color: {
      type: String,
      default: "white"
    },
    borderColor: {
      type: String
    },
    headerBgColor: {
      type: String
    },
    headerColor: {
      type: String,
      default: "#333"
    }
  },
  computed: {}
};
</script>
<style scoped>
.card {
  background-color: white;
  margin-bottom: 20px;
  border-style: solid;
  border-radius: 4px;
  overflow: hidden;
  box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14),
    0 1px 5px 0 rgba(0, 0, 0, 0.12);
  color: rgba(0, 0, 0, 0.87);
}

.card-content {
  padding: 10px;
}
.card-header {
  padding: 10px;
  text-align: center;
  box-shadow: 0 0px 5px 0 rgba(0, 0, 0, 0.12);
  /* color: white; */
  font-weight: bold;
  font-size: 18px;
  overflow: hidden;
}
</style>